module.exports = __webpack_public_path__ + "img/pic2.3af3331c.png";